import React, { useContext, useRef, useState } from "react";
import HeaderWithBackButton from "../common/HeaderWIthBackButton";
import { contextStore } from "../../context/CustomStateProvider";
import { Toast } from "primereact/toast";

const VedaConsultLayout = (props: any) => {
  const context = useContext(contextStore);
  const resource = context.state.strings;
  const toast = useRef<Toast>(null);

  const [backButton, setBackButton] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // 🔹 Header button controls
  const cardControls = [
    {
      ctrlType: "button",
      name: "btnAddConsult",
      title: resource.addNewConsult || "Add New Consultation",
      type: "button",
      disabled: false,
      className: "green-btn",
    },
  ];

  // 🔹 When header button clicked
  const onButtonClick = (e: string) => {
    if (e === "btnAddConsult") {
      toast.current?.show({
        severity: "info",
        summary: "VedaConsult",
        detail: "Add Consultation clicked",
        life: 2000,
      });
    }
  };

  // 🔹 When back button clicked
  const onBackButtonClick = () => {
    setBackButton(!backButton);
  };

  // 🔹 When search changes
  const handleSearch = (event: any) => {
    setSearchQuery(event.target.value);
  };

  return (
    <div className="container">
      <Toast ref={toast} />

      {/* 🔹 Header */}
      <HeaderWithBackButton
        title={resource.vedaConsultDetails || "VedaConsult Details"}
        controls={cardControls}
        onButtonClicked={onButtonClick}
        handleSearch={handleSearch}
        onBackButtonClick={onBackButtonClick}
        searchQuery={searchQuery}
      />

      {/* 🔹 Content Section */}
      <div className="mt-4 text-center">
        <h3>{resource.vedaConsult || "Welcome to VedaConsult"}</h3>
        <p className="text-muted">
          Manage AI-based consultations.
        </p>
        <p>
          Use the “Add New Consultation” button above to start creating
          consultation entries.
        </p>
      </div>
    </div>
  );
};

export default VedaConsultLayout;
